import { Directive } from '@angular/core';
var LyInputContents = /** @class */ (function () {
    function LyInputContents() {
    }
    LyInputContents.decorators = [
        { type: Directive, args: [{
                    selector: 'ly-before-input, ly-after-input'
                },] },
    ];
    /** @nocollapse */
    LyInputContents.ctorParameters = function () { return []; };
    return LyInputContents;
}());
export { LyInputContents };
//# sourceMappingURL=input-contents.js.map